module.exports = __webpack_public_path__ + "components/media-kit/static/media-kit-background-10c4057c054309453d5f4640b704b81f.jpg";